define('app/collections/feedback_rate_collection',['app/setup','app/models/vendor_rate_model'], function(takhfifan, VendorRate) {

  takhfifan.FeedbackRateCollection = Backbone.Collection.extend({
    model : takhfifan.VendorRate,
    url: '/ajax/landing/registerSurvey',
    rate: function (options) {
      this.fetchCallback = options.success;
      this.fetchCallbackFail = options.fail;
      this.submitRateModel({data: options.data, url: this.url, type: 'post'});
    },
    submitRateModel: function(options){
      var _this = this;
      $.ajax(options).done(function (data, textStatus, jqXHR) {
        if (jqXHR.status == 204) {
          _this.submitRateModel.call(_this, options);
        } else {
          if(textStatus==="success"){
            _this.processSubmitRateResults(data || []);
          }
        }
      }).fail(function (e) {
        _this.processSubmitRateFail(e);
        console.error("submit rate error: ", e);
      }).always(function () {
      });
    },
    processSubmitRateResults: function (results) {
      this.fetchCallback(results);
    },
    processSubmitRateFail:function () {
      this.fetchCallbackFail();
    }

  });

});
